import React, { useEffect, useState } from 'react'
import { useStyles } from './HomepageCompanyLogos_style'
import { Box, Container, Typography, Grid } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import HomeAPI from 'api/HomeAPI'
import { FormattedMessage } from 'react-intl'
import { MEDIUM_SIZE } from 'assets/CloudinaryURLHelper'

const HomepageCompanyLogos = (props) => {
    const classes = useStyles()
    const { showTitle, showCTA } = props
    const [homepageCompanyLogos, setHomepageCompanyLogos] = useState([])

    useEffect(() => {
        HomeAPI.GetCompanyLogos().then((response) => {
            setHomepageCompanyLogos(response.data.homepage_logos_companies)
        })
    }, [])

    return (
        <Box className={classes.theyTrustUs}>
            <Container maxWidth='lg' className={classes.whyUsContainer}>
                {showTitle &&
                    <Box className={classes.titleSection}>
                        <Typography variant='h6' component='h2' className={classes.pageTitleFullWidth}>
                            <FormattedMessage id='landing_employer.they_trust_us.title' />
                        </Typography>
                        <Typography className={classes.pageSubTitle}>
                            <FormattedMessage id='landing_employer.they_trust_us.subtitle' />
                        </Typography>
                    </Box>
                }
                <Grid container justifyContent='center' spacing={2} className={classes.partnerBox}>
                    {homepageCompanyLogos.map(company =>
                        <Grid key={company.logo_cloudinary_key} item xs={4} sm={2} spacing={0} className={classes.partnerImageBox}>
                            <RouteMapLink showItemType='company' showItemUrl={company.url} target='_blank'>
                                <Image
                                    className={classes.partnerImage}
                                    cloudName='studentbe'
                                    publicId={`${company.logo_cloudinary_key}`}
                                    alt={`${company.logo_cloudinary_key}`}
                                >
                                    <Transformation flags='progressive' fetchFormat='auto' width={MEDIUM_SIZE} quality='auto:best' crop='fill' />
                                </Image>
                            </RouteMapLink>
                        </Grid>
                    )}
                </Grid>
                {showCTA &&
                    <Box className={classes.titleSection}>
                        <RouteMapLink page='employers'>
                            <FormattedMessage id='landing_employer.they_trust_us.cta'>
                                {text => <Typography className={classes.pageSubTitle} variant='h6' component='h1' dangerouslySetInnerHTML={{ __html: text }} />}
                            </FormattedMessage>
                        </RouteMapLink>
                    </Box>
                }
            </Container>
        </Box>
    )
}

export default HomepageCompanyLogos
